module.exports = __webpack_public_path__ + "static/img/apple-qr.e71fd0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apple-qr.png
// module id = Kqga
// module chunks = 1